import React from 'react'

const Insights = () => {
  return (
    <div>Insights</div>
  )
}

export default Insights